import React, {useState} from 'react';
import {useMutation} from 'react-apollo-hooks';
import gql from 'graphql-tag';
import uuid from 'uuid/v4';

import {Button, Modal} from 'ui-kit';
import CircleCheck from 'images/circle-ok.svg';
import CircleCheckGray from 'images/circle-ok-gray.svg';

import * as styles from './BenefitsModal.module.css';

const formatDate = new Intl.DateTimeFormat('en-US').format;

export function BenefitsModal({
  show,
  onDismiss,
  firstName,
  lastName,
  benefits,
  benefitUses,
  membershipPlanSubscriptionId,
  onSubmit,
}) {
  const [loading, setLoading] = useState(false);

  const mutate = useMutation(gql`
    mutation CreateBenefitUse($input: CreateBenefitUseInput!) {
      createBenefitUse(input: $input) {
        benefitUse {
          id
        }
        errors {
          path
          message
        }
      }
    }
  `);

  async function handleAvailableBenefitClick(benefitId) {
    setLoading(true);

    await mutate({
      variables: {
        input: {
          membershipPlanSubscriptionId,
          benefitId,
          performedAt: new Date(),
        },
      },
    });

    setLoading(false);
    onSubmit();
  }

  return (
    <Modal show={show} onDismiss={onDismiss}>
      <h2 className={styles.Heading}>
        Track benefits for {firstName} {lastName}
      </h2>

      {benefits.length === 0 ? (
        <div>
          <p>This plan does not include any trackable benefits.</p>
        </div>
      ) : (
        benefits.map(benefit => {
          const uses = benefitUses.filter(use => use.benefit.id === benefit.id);
          const availableQuantity = benefit.quantity - uses.length;

          return (
            <div key={benefit.id}>
              <h4>{benefit.name}</h4>

              {uses.map(({id, performedAt}) => (
                <div className={styles.Check} key={id}>
                  <img src={CircleCheck} alt="" className={styles.CheckImage} />
                  <div className={styles.CheckText}>
                    <p>Performed on {formatDate(new Date(performedAt))}</p>
                  </div>
                </div>
              ))}
              {Array.from(Array(availableQuantity)).map(() => (
                <button
                  className={styles.Check}
                  key={uuid()}
                  onClick={() => handleAvailableBenefitClick(benefit.id)}
                  type="button"
                  disabled={loading}
                >
                  <img
                    src={CircleCheckGray}
                    alt=""
                    className={styles.CheckImage}
                  />
                  <div className={styles.CheckText}>
                    <p>Available</p>
                  </div>
                </button>
              ))}
            </div>
          );
        })
      )}

      <div className={styles.Footer}>
        <Button type="button" onClick={onDismiss} color="light">
          Close
        </Button>
      </div>
    </Modal>
  );
}
